import styled from "styled-components";
import Slider from "../../../structures/others/slider/index.js";
export const CarouselHeaderBlock = styled.div.withConfig({
    displayName: "styled__CarouselHeaderBlock",
    componentId: "sc-1c85cb6f-0"
})`
	overflow: hidden;
	max-width: 1920px;
	margin: 0 auto;
`;
export const CarouselHeaderSlider = styled(Slider).withConfig({
    displayName: "styled__CarouselHeaderSlider",
    componentId: "sc-1c85cb6f-1"
})`
	position: relative;
	height: 375px;

	.splide__track {
		height: 100%;
	}

	.splide__slide {
		a,
		figure,
		img {
			height: 100%;
		}
		img {
			min-width: 100%;
			max-width: 100%;
			width: 1920px;
			height: 100%;
			object-fit: cover;
			object-position: center;
		}
	}
`;

//# sourceMappingURL=styled.js.map